import { configureStore } from "@reduxjs/toolkit";
import appointmentReducer from "./slices/appointmentSlice";
import shopReducer from "./slices/shopSlice";

/**
 * Centralized Redux store configuration
 */
const store = configureStore({
  reducer: {
    appointments: appointmentReducer,
    shops: shopReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
